import { useState } from 'react'
import { DownArrowIcon } from '../icons'

type AccordionProps = {
  defaultOpen?: boolean
  title: string
  children: React.ReactNode
}

/* Accordion component */

export const Accordion = ({ title, children, defaultOpen = false }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  return (
    <div
      className="flex flex-col w-full gap-3 pt-4 lg:pt-0 max-lg:border-t max-lg:border-neutral-80"
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="flex justify-between w-full cursor-pointer">
        <h3 className="font-normal text-s">{title}</h3>
        <DownArrowIcon
          style={{ transform: isOpen ? undefined : 'rotate(-180deg)', transition: 'all .5s ease' }}
          className="lg:hidden text-white"
        />
      </div>
      <div className="flex flex-col gap-4" style={{ transition: 'all .5s ease' }}>
        {isOpen && children}
      </div>
    </div>
  )
}
